import BadgeCollection from './BadgeCollection';

export default BadgeCollection;
